import { render } from "./batchSendGsZf.vue?vue&type=template&id=f1ebc050&scoped=true"
import script from "./batchSendGsZf.vue?vue&type=script&lang=js"
export * from "./batchSendGsZf.vue?vue&type=script&lang=js"

import "./batchSendGsZf.vue?vue&type=style&index=0&id=f1ebc050&lang=less&scoped=true"
import "./batchSendGsZf.vue?vue&type=style&index=1&id=f1ebc050&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1ebc050"]])

export default __exports__